import React from "react";

export function MockWindow({ title = "MetaTrader 5", rows, caption = "Illustration - your MT5 may look slightly different depending on your broker." }) {
  return (
    <div className="mt-5" data-testid="mock-window">
      <div className="rounded-xl overflow-hidden border border-[#1E3A8A] shadow-[0_10px_40px_rgba(0,0,0,0.45)]">
        <div className="flex items-center gap-2 px-4 py-2.5 bg-[#DCE4EE]">
          <span className="w-3 h-3 rounded-full bg-[#FF6B6B]" />
          <span className="w-3 h-3 rounded-full bg-[#FBBF24]" />
          <span className="w-3 h-3 rounded-full bg-[#34D399]" />
          <span className="ml-2 text-xs font-semibold text-[#1E293B] truncate">{title}</span>
        </div>
        <div className="bg-[#EEF3F8] px-5 py-4 space-y-2.5">
          {rows.map((r, i) => {
            const row = typeof r === "string" ? { t: r } : r;
            return (
              <div
                key={i}
                className={`text-sm sm:text-base text-[#1E293B] px-3 py-2 rounded-lg ${row.hl ? "border-2 border-[#10B981] bg-white font-semibold" : ""} ${row.mono ? "font-mono" : ""}`}
              >
                {row.t}
              </div>
            );
          })}
        </div>
      </div>
      <div className="mt-2 text-[10px] uppercase tracking-widest text-[#64748B]">{caption}</div>
    </div>
  );
}

export function Shot({ src, cap, id }) {
  const url = `/guide/${src}.jpg`;
  return (
    <figure className="mt-5" data-testid={`guide-shot-${id}`}>
      <a href={url} target="_blank" rel="noreferrer" className="inline-block max-w-full align-top rounded-xl overflow-hidden border border-[#1E3A8A] shadow-[0_10px_40px_rgba(0,0,0,0.45)] hover:border-[#34D399] transition-colors">
        <img src={url} alt={cap} loading="lazy" className="max-w-full h-auto block" />
      </a>
      <figcaption className="mt-2 text-xs text-[#94A3B8]"><span className="text-[#34D399] font-semibold">Look for the green boxes.</span> {cap} <span className="text-[#64748B]">(tap to enlarge)</span></figcaption>
    </figure>
  );
}

export function ChartBanner({ botName }) {
  return (
    <div className="mt-5 rounded-xl overflow-hidden border border-[#1E3A8A]" data-testid="mock-chart-banner">
      <div className="relative h-48 bg-[#0B1220]" style={{ backgroundImage: "linear-gradient(#162033 1px, transparent 1px), linear-gradient(90deg, #162033 1px, transparent 1px)", backgroundSize: "40px 40px" }}>
        <div className="absolute top-3 left-3 bg-[#228B22] px-4 py-2.5 shadow-lg">
          <div className="text-white font-black text-base sm:text-lg tracking-tight">BotGenomix&nbsp; | &nbsp;LICENCE OK</div>
          <div className="text-white/90 text-xs mt-0.5">Trading active - next check 18:30</div>
        </div>
        <div className="absolute top-3 right-3 text-[#38BDF8] text-xs font-mono">{botName}</div>
        <svg className="absolute bottom-4 left-0 w-full h-24" viewBox="0 0 400 100" preserveAspectRatio="none">
          <polyline fill="none" stroke="#38BDF8" strokeWidth="2" points="0,80 40,70 80,75 120,50 160,58 200,40 240,46 280,25 320,32 360,15 400,20" />
        </svg>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 text-xs">
        <div className="px-4 py-2 bg-[#228B22]/20 text-[#4ADE80]"><b>Green</b> - licence OK, bot trading</div>
        <div className="px-4 py-2 bg-[#FF8C00]/20 text-[#FDBA74]"><b>Orange</b> - can't reach our server, 24h grace</div>
        <div className="px-4 py-2 bg-[#DC143C]/20 text-[#FCA5A5]"><b>Red</b> - licence refused, trading paused</div>
      </div>
    </div>
  );
}
